import { useSettings } from '@backpackjs/storefront';

import { Link } from '../Link';
import { Svg } from '../Svg';

export function FooterSocial() {
  const settings = useSettings();
  const { links } = { ...settings?.footer?.social };

  return links?.length > 0 ? (
    <div className="text-current">
      <ul className="flex flex-wrap gap-3.5">
        {links.map(({ platform, url }, index) => {
          return (
            <li key={index}>
              <Link aria-label={platform} href={url} newTab>
                <Svg
                  className="w-6 text-current transition md:hover:opacity-80"
                  src={`/svgs/noprecache/social/${platform}.svg#${platform}`}
                  title={platform}
                  viewBox="0 0 24 24"
                />
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;
}

FooterSocial.displayName = 'FooterSocial';
